<!-- Innovadis custom: added class name to be able to style conditionally -->
<!-- Innovadis custom: formatting-->
<template>
  <span class="vc-price-display">{{ bossardFormattedAmount }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { MoneyType } from "@/core/api/graphql/types";
import { getBossardFormattedNumber } from "@/core/utilities/innovadis";

interface IProps {
  value?: MoneyType;
  showCurrencySymbol?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  showCurrencySymbol: false,
});

const bossardFormattedAmount = computed(() => {
  const amount = props.value?.amount ?? 0;
  return props.showCurrencySymbol
    ? `${props.value?.currency?.symbol ?? "Є"}${getBossardFormattedNumber(amount)}`
    : getBossardFormattedNumber(amount);
});
</script>
